import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { IFinalResponse } from '_core/types';
import { UploadFileS3Types } from '../Types';

const machine = Machines.onUploadFileS3.machine;

export const uploadFileS3 = (
  params: UploadFileS3Types.UploadFileS3ServiceRequestType,
): Promise<IFinalResponse> => {
  return callServiceMachine(machine, params);
};

export default { uploadFileS3 };
